import { ERegionCode } from '@sureapp/platform-sdk';

import wlConfig from '@@/constants/wlConfig';
import { TConfig } from '@@/interfaces';
import { isServer } from '@@/services/env';
import { mergeConfigs } from '@@/services/mergeConfig';
import regionConfigMerge from '@@/services/regionConfigMerge';

const defaultRegionConfig = require('./region/toggle');

type TOpts = {
  tenant: string;
  region?: ERegionCode;
};

// Try fetching the region overrides first. Fall back to region/:tenant/index
// if no region override exists.
function retrieveConfig({ tenant, region }: TOpts) {
  /* eslint-disable import/no-dynamic-require, global-require */
  try {
    return require(`./region/${tenant}/${region}`).default;
  } catch {
    try {
      return require(`./region/${tenant}`).default;
    } catch {
      return {};
    }
  }
  /* eslint-enable import/no-dynamic-require, global-require */
}

const tenant = process.env.REACT_APP_TENANT || 'toggle';

function getEnvConfig(opts: TOpts): DeepPartial<TConfig> {
  if (isServer || !tenant) {
    return {};
  }

  const { configTestHelper, Cypress } = window;

  const config = retrieveConfig(opts);

  return (
    (Cypress &&
      configTestHelper &&
      (configTestHelper(config) as DeepPartial<TConfig>)) ||
    config ||
    {}
  );
}

const mergedConfig = mergeConfigs<DeepPartial<TConfig>>(
  wlConfig,
  defaultRegionConfig.default,
  getEnvConfig({ tenant })
) as TConfig;

export function getRegionConfigByCode(region?: ERegionCode): TConfig {
  const mergedRegionConfig = mergeConfigs<DeepPartial<TConfig>>(
    getEnvConfig({ region, tenant: 'toggle' }),
    getEnvConfig({ region, tenant })
  ) as TConfig;
  return regionConfigMerge(mergedConfig, mergedRegionConfig);
}

export default mergedConfig;
